import { useTranslation } from 'react-i18next';
import { MobileDropdownStyled } from 'src/components';
import { FilterItems, SortItems } from '.';
import type { OrgFilterBy, OrgSortBy } from 'src/types';
type Props = {
  filterBy: OrgFilterBy;
  sortBy: OrgSortBy;
  setFilterBy: (filterBy: OrgFilterBy) => void;
  setSortBy: (sortBy: OrgSortBy) => void;
};

export const MobileDropdown = ({
  filterBy,
  sortBy,
  setFilterBy,
  setSortBy,
}: Props) => {
  const { t } = useTranslation();

  return (
    <MobileDropdownStyled darkIcon={true}>
      {(closeDropdown) => (
        <>
          {/* Sort By Section */}
          <div className='flex flex-col items-start gap-2 px-3 pb-4 pl-3 pr-4 font-semibold xs:px-6'>
            <SortItems
              handleClick={closeDropdown}
              sortBy={sortBy}
              setSortBy={setSortBy}
            />
          </div>

          {/* Filter By Section */}
          <div className='inline-flex w-full justify-between p-2 xs:p-3'>
            <span className='whitespace-nowrap font-secondary text-primary-dark'>
              {t('org_settings.filter_by')}:
            </span>
          </div>
          <div className='flex flex-col items-start gap-2 px-3 pb-6 pl-3 pr-4 font-semibold xs:px-6'>
            <FilterItems
              handleClick={closeDropdown}
              filterBy={filterBy}
              setFilterBy={setFilterBy}
            />
          </div>
        </>
      )}
    </MobileDropdownStyled>
  );
};
